import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import Section from '../components/Section.jsx';
import { differentials, trustPoints } from '../content.js';

export default function Differentials() {
  return (
    <Section
      id="diferenciais"
      eyebrow="Por que funciona"
      title="Desenhado para a realidade do condomínio"
    >
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Grid container spacing={3}>
            {differentials.map((item) => (
              <Grid key={item.title} size={{ xs: 12, sm: 6 }}>
                <Box
                  sx={{
                    height: '100%',
                    p: 3,
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, md: 5 }}>
          <Box
            sx={{
              p: 3.5,
              borderRadius: 3,
              height: '100%',
              border: '1px solid',
              borderColor: 'secondary.main',
              bgcolor: 'rgba(245,185,59,0.06)',
            }}
          >
            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', mb: 2 }}>
              <ShieldOutlinedIcon sx={{ color: 'secondary.main' }} />
              <Typography variant="h6" component="h3">
                Privacidade em primeiro lugar
              </Typography>
            </Stack>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              A leitura das mensagens acontece somente nos grupos conectados pelo síndico e apenas
              para moradores que autorizaram. Quem não autorizou fica de fora da triagem, sem perder
              o acesso ao restante da plataforma.
            </Typography>

            <Stack spacing={1.25}>
              {trustPoints.map((point) => (
                <Typography key={point} variant="body2">
                  &bull; {point}
                </Typography>
              ))}
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
}
